import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { optimizationApi, type PerformanceProfile } from '../../api/optimization';

export function PerformanceEngineeringPage() {
  const [profiles, setProfiles] = useState<PerformanceProfile[]>([]);
  useEffect(() => { void optimizationApi.performance().then(setProfiles); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Performance Engineering Dashboard</h1>
      <Link to="/optimization" className="mt-2 inline-block text-sm text-violet-700 hover:underline dark:text-violet-400">← Optimization Center</Link>
      <div className="mt-6 overflow-x-auto rounded-xl border dark:border-slate-700">
        <table className="min-w-full text-sm"><thead className="bg-slate-50 dark:bg-slate-800"><tr><th className="px-4 py-2 text-left">Module</th><th className="px-4 py-2 text-left">P50</th><th className="px-4 py-2 text-left">P95</th><th className="px-4 py-2 text-left">P99</th><th className="px-4 py-2 text-left">Score</th></tr></thead>
          <tbody>{profiles.map((p) => (<tr key={p.id} className="border-t dark:border-slate-700"><td className="px-4 py-2">{p.module}</td><td className="px-4 py-2">{p.p50_ms}ms</td><td className="px-4 py-2">{p.p95_ms}ms</td><td className="px-4 py-2">{p.p99_ms}ms</td><td className="px-4 py-2">{p.score}</td></tr>))}</tbody>
        </table>
      </div>
    </div>
  );
}
